<!--
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-05-08 16:58:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/approve/contract/end-list.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="ExamineProcessing">待审批</el-menu-item>
          <el-menu-item index="Processing">已审批</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <auth-list v-if="showComponent" :type="activeIndex"></auth-list>
      </div>
    </div>
  </div>
</template>

<script>
import authList from "./end/list";
export default {
  data() {
    return {
      activeIndex: "ExamineProcessing",
      queryData: {},
      showComponent: true,
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.activeIndex = this.$route.query.tab;
    }
  },
  components: {
    authList
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.showComponent = false;
      setTimeout(() => {
        this.showComponent = true;
      }, 0)
    }
  }
}
</script>